import { useTranslation } from '../i18n';
import { getLocalizedVideo, VideoType } from '../utils/videoUtils';

/**
 * Custom hook to get localized video paths based on current language
 * @param videoType - The type of video to get
 * @returns The localized video path
 */
export function useLocalizedVideo(videoType: VideoType): string {
  const { i18n } = useTranslation();
  return getLocalizedVideo(videoType, i18n.language);
}

/**
 * Custom hook to get a video path for a creation type name (legacy compatibility)
 * @param creationTypeName - The creation type name
 * @returns The localized video path or undefined
 */
export function useCreationTypeVideo(creationTypeName: string): string | undefined {
  const { i18n } = useTranslation();
  
  if (creationTypeName === 'c-roll') {
    return getLocalizedVideo('c-roll', i18n.language);
  }
  if (creationTypeName === 'podcast-moments') {
    return getLocalizedVideo('best-moments', i18n.language);
  }
  return undefined;
} 